import DeleteModal from "components/Common/DeleteModal"
import Spinners from "components/Shared/Spinners"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import {
  cancelInterview,
  candidateInterviewReject,
  getAvailableSlots,
  interviewApply,
} from "store/actions/jobApplicationAction"
import { showAlert } from "store/reducers/alertReducer"
import HTMLModal from "./components/HTMLModal"
import NoDataAvailable from "../../components/Shared/NoDataAvailable"

const MyInterviews = () => {
  const { loading, availableSlots, isLoading } = useSelector(
    state => state.JobApplication
  )
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  document.title = t("My Interviews | Yamama")

  const dispatch = useDispatch()
  const [selectedUuid, setSelectedUuid] = useState(null)
  const [selectedItem, setSelectedItem] = useState({})
  const [modal, setModal] = useState(false)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const handleToggle = () => setIsOpen(!isOpen)
  const [reachedLimitMsg, setReachedLimitMsg] = useState(null)
  const [selectedDescription, setSelectedDescription] = useState("")
  const [showHtmlModal, setShowHtmlModal] = useState(false)

  useEffect(() => {
    getAllData()
  }, [])

  const getAllData = () => {
    dispatch(getAvailableSlots())
  }

  const handleAcceptReject = () => {
    const payload = {
      uuid: selectedUuid,
    }
    dispatch(interviewApply(payload))
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          setSelectedUuid(null)
          setModal(null)
          getAllData(message)
        } else {
          if (data?.show_reached_limit_popup) {
            setReachedLimitMsg(message)
            toggle()
            handleToggle()
            setSelectedUuid(null)
          } else {
            dispatch(showAlert({ text: message, type: "error" }))
            setSelectedUuid(null)
          }
        }
      })
      .catch(error => {})
  }

  const toggle = () => setModal(!modal)

  const [selectedSlot, setSelectedSlot] = useState(null)

  const handleCancelInterview = uuid => {
    const payload = {
      uuid,
    }
    dispatch(cancelInterview(payload))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          getAllData()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleReject = () => {
    const payload = {
      uuid: itemIdToDelete,
    }
    dispatch(candidateInterviewReject(payload))
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          getAllData()
          setShowDeleteModal(false)
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const showCurrentLanguageDescription = () => {
    if (i18n.language === "en") {
      if (
        selectedDescription.en === "<p><br></p>" ||
        selectedDescription.en === ""
      ) {
        return selectedDescription.ar
      } else {
        return selectedDescription.en
      }
    } else {
      if (
        selectedDescription.ar === "<p><br></p>" ||
        selectedDescription.ar === ""
      ) {
        return selectedDescription.en
      } else {
        return selectedDescription.ar
      }
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <Col xl="12">
                <h4 className="card-title mb-4">{t("My Interviews Slots")}</h4>
                <Card className="user_personal_info theme_card overflow-x-auto">
                  <CardBody>
                      <Table className="table mb-0 table-responsive">
                        <thead className="table-light full_th">
                          <tr>
                            <th>{t("S. No.")}</th>
                            <th>{t("Title")}</th>
                            {/* <th>{t("Description")}</th> */}
                            <th>{t("Start Date")}</th>
                            <th>{t("End Time")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {availableSlots?.map((item, index) => (
                            <tr key={index}>
                              <th scope="row">{index + 1}</th>
                              <td>{item?.title}</td>
                              <td>
                                <p className="fit_content ltr">
                                  {item?.start_date} ~ {item?.end_time}
                                </p>
                              </td>
                              <td>
                                <p className="fit_content ltr">
                                  {item?.end_date} ~ {item?.end_time}
                                </p>
                              </td>
                              <td>
                                <div className="d-flex gap-3">
                                  <Button
                                    color="primary"
                                    className="fit_content"
                                    onClick={() => {
                                      setSelectedDescription({
                                        en: item.description,
                                        ar: item.description_ar,
                                      })
                                      setShowHtmlModal(true)
                                      // handleAcceptReject(item?.uuid)
                                    }}
                                  >
                                    {t("View Instructions")}
                                  </Button>
                                  {item?.can_apply && (
                                    <Button
                                      color="primary"
                                      className="fit_content"
                                      onClick={() => {
                                        toggle()
                                        setSelectedUuid(item?.uuid)
                                        setSelectedItem(item)
                                        // handleAcceptReject(item?.uuid)
                                      }}
                                    >
                                      {t("Book Your Time Slots")}
                                    </Button>
                                  )}
                                  {item?.is_cancelled ? (
                                    <p className="text-danger text-uppercase font-bold">
                                      {t("Cancelled")}
                                    </p>
                                  ) : (
                                    // : item?.is_rejected ? (
                                    //   <p className="text-danger text-uppercase font-bold">
                                    //     {t("Invitation Rejected")}
                                    //   </p>
                                    // )
                                    !item?.can_cancel &&
                                    !item?.can_apply && (
                                      <Button
                                        color="primary"
                                        className="fit_content"
                                        disabled={!item?.can_apply}
                                        onClick={() => {
                                          toggle()
                                          setSelectedUuid(item?.uuid)

                                          // handleAcceptReject(item?.uuid)
                                        }}
                                      >
                                        {t("Book Your Time Slots")}
                                      </Button>
                                    )
                                  )}
                                  {/* {item?.can_cancel && (
                                    <Button
                                      color="danger"
                                      onClick={() =>
                                        handleCancelInterview(item?.uuid)
                                      }
                                      className="fit_content"
                                    >
                                      {t("Cancel Slot")}
                                    </Button>
                                  )} */}
                                  {/* {item?.can_reject && (
                                    <Button
                                      color="danger"
                                      onClick={() => {
                                        setItemIdToDelete(item.uuid)
                                        setShowDeleteModal(true)
                                      }}
                                      className="fit_content"
                                    >
                                      Reject
                                    </Button>
                                  )} */}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    {!loading && availableSlots?.length === 0 && (
                      <NoDataAvailable text="No Slots Available" />
                      )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        )}
      </div>
      {showHtmlModal && (
        <HTMLModal
          isOpen={showHtmlModal}
          toggle={() => setShowHtmlModal(!showHtmlModal)}
          dangerousHTML={showCurrentLanguageDescription()}
        />
      )}
      <Modal isOpen={modal} toggle={toggle} size="md" backdrop="static">
        <ModalHeader toggle={toggle}>{t("Book Your Time Slots")}</ModalHeader>
        <ModalBody>
          <div className="row g-2">
            <h4>
              {t("Are you sure you want to confirm this date and time slots")}
            </h4>
            <h5>
              {t("Scheduled Date")} {selectedItem?.start_date}
            </h5>
            <h5 className="d-flex">
              {t("Time")}{" "}
              <p className="ltr fit_content px-2">
                {" "}
                {selectedItem?.start_time} ~ {selectedItem?.end_time}
              </p>
            </h5>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            {t("Close")}
          </Button>
          <Button
            color="primary"
            onClick={handleAcceptReject}
            isLoading={isLoading}
          >
            {t("Book")}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={isOpen} toggle={handleToggle}>
        <ModalHeader toggle={handleToggle}>{t("Confirmation")}</ModalHeader>
        <ModalBody>
          <div className="row g-2">
            <h4>{reachedLimitMsg}</h4>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleToggle}>
            {t("Close")}
          </Button>
        </ModalFooter>
      </Modal>
      <DeleteModal
        show={showDeleteModal}
        onDeleteClick={handleReject}
        onCloseClick={() => {
          setItemIdToDelete(null)
          setShowDeleteModal(false)
        }}
        isLoading={isLoading}
        buttonText={t("Reject")}
        bodyTitle={t("Are you sure you want to reject this {{name}}?", {
          name: t("Invitation"),
        })}
      />
    </React.Fragment>
  )
}

export default MyInterviews
